import z from 'zod';
import {
  GetListingsV3PublicEndpoint,
  GetListingsV3PublicResponseSchema,
  GetListingV3PublicResponseSchema,
  PictureResolutions,
  ResourceGroupExperienceSchemaV3,
} from '@kouto/types';
import { ExtractNullableField } from '@utils/types/ExtractNullableField';

/**
 * PublicListingV3: Backend V3 response schema schema for get all listings endpoint
 */
export type PublicListingV3 = z.infer<
  typeof GetListingsV3PublicResponseSchema
>['items'][number];

/**
 * PublicListingDetailsV3: Backend V3 response schema for get listing by id
 */
export type PublicListingDetailsV3 = z.infer<
  typeof GetListingV3PublicResponseSchema
>;

export type ResourceGroupExperienceV3 = z.infer<
  typeof ResourceGroupExperienceSchemaV3
>;

export interface ListingsV3QueryProps
  extends Omit<
    z.infer<typeof GetListingsV3PublicEndpoint.querySchema>,
    'page'
  > {
  page?: z.infer<typeof GetListingsV3PublicEndpoint.querySchema>['page'];
}

export const HostMediaImageResolutions = PictureResolutions;

export type HostedBy = PublicListingV3['hostedBy'];
type Category = PublicListingV3['category'];
type Vibes = PublicListingV3['vibes'];
type ResourceGroups = PublicListingV3['resourceGroups'];

/**
 * NormalizedPublicListing: V3 listing type for the brand embed script
 */
export type NormalizedPublicListing = {
  categoryId: ExtractNullableField<Category, 'id'>;
  categoryName: ExtractNullableField<Category, 'name'>;
  experienceId: PublicListingV3['experienceId'];
  hostedBy: HostedBy;
  id: PublicListingV3['id'];
  medias: PublicListingV3['medias'];
  pointsEligible: PublicListingV3['pointsEligible'];
  productLine: PublicListingV3['productLine'];
  resourceGroupCollectionId: PublicListingV3['resourceGroupCollectionId'];
  resourceGroups: ResourceGroups; // @todo-v3: is this needed?
  advertisedPrice: PublicListingV3['advertisedPrice'];
  startingPrice: PublicListingV3['startingPrice'];
  title: PublicListingV3['title'];
  vibes: Vibes;
  kind: PublicListingV3['kind'];
  bookingAvailabilityMode: PublicListingV3['bookingAvailabilityMode'];
  brandId: PublicListingV3['brandId'];
  dates: PublicListingV3['eventDates']; // @todo-v3: should we rename this to eventDates for clarity?
  hidePrice: PublicListingV3['hidePrice'];
  isExclusive: PublicListingV3['isExclusive'];
  maxParticipants: PublicListingV3['maxParticipants'];
  slug: PublicListingV3['slug'];
  summary: PublicListingV3['summary'];
  rating: PublicListingV3['rating'];
  promotedListing: PublicListingV3['promotedListing'];
};
